import script from "./WorkItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkItemList.vue?vue&type=script&setup=true&lang=js"

import "./WorkItemList.vue?vue&type=style&index=0&id=0bd0236e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd0236e"]])

export default __exports__